export const eudrAdditionalInformationStructure = [
	{
		label: 'Subscription Plan',
		key: 'subscriptionPlanName',
		type: 'text',
	},
	// {
	// 	label: 'Covered Product Types',
	// 	key: 'productTypes',
	// 	type: 'text',
	// },
	{
		label: 'Valid Till',
		key: 'periodEnd',
		type: 'date',
	},
	{
		label: 'Service Status',
		key: 'serviceStatusName',
		type: 'text',
	},
	// {
	// 	label: 'Confirmation Status',
	// 	key: 'confirmationStatus',
	// 	type: 'text',
	// },
];
